import React, { useState, useEffect, useRef } from "react";
import Footer from "components/Footers/Footer.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import truck from "assets/img/truck.png";
import girl from "assets/img/girl.jpg";
import home1 from "assets/img/home1.png";
import home2 from "assets/img/home2.png";
import home3 from "assets/img/home3.png";
import home4 from "assets/img/home4.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import Slider2 from "components/Homepage/Slider2";
import bgfruits from "assets/img/bgfruits.jpg";
import tomatoo from "assets/img/tomatoo.png";

import newbg from "assets/img/newbg.jpg";
import newimg from "assets/img/newimg.png";
import icon5 from "assets/img/icon5.png";
import icon6 from "assets/img/icon6.png";
import icon7 from "assets/img/icon7.png";
import icon8 from "assets/img/icon8.png";
import icon9 from "assets/img/icon9.png";
import vapour from "assets/img/vapour.jpg";
import bgg3 from "assets/img/bgg3.png";
import bgg1 from "assets/img/bgg1.png";
import servicesbg2 from "assets/img/servicebg2.png";
import basket from "assets/img/basket1.png";
import silos from "assets/img/silos.png";
import storagetanks from "assets/img/storagetanks.png";
import processtanks from "assets/img/processtanks.png";
import mixingtank from "assets/img/mixingtank.png";
import cpitanks from "assets/img/cpitanks.png";
import incubationtanks from "assets/img/incubationtanks.png";
import buttermeltingtank from "assets/img/buttermeltingtank.png";
import jackedtedtanks from "assets/img/jacketedtanks.png";
import ribbonblender from "assets/img/ribbonblender.png";
import drymixingtank from "assets/img/drymixingtank.png";
import milktank from "assets/img/milktank.png";
import insulatedtank from "assets/img/insulatedtank.png";
import abtimg from "assets/img/abtimg.jpg";
import { Form } from "formik";
import Popup from "./Popup";


export default function Product() {
  const [buttonPopup, setButtonPopup] = useState(false);
  return (
    <section className="poppins">
      <IndexNavbar />

      <section className="xl:pt-0 lg:pt-0 md:pt-24 pt-20">
        <div
          className="relative xl:h-400 lg:h-300 md:h-240 h-200-px"
          style={{
            backgroundImage: `url(${newbg})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
          {/* Black Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>

          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="xl:gap-0">
              <div className="xl:pt-32 lg:pt-24 md:pt-20 pt-16">
                <h1 className="xl:text-7xl lg:text-5xl md:text-4xl text-4xl text-center text-white uppercase font-bold fade-item-1">
                  product
                </h1>

                <div>
                  <div className="flex items-center justify-center bg-[#FDF5E6] rounded-lg xl:mt-6 lg:mt-4 mt-4">
                    <div
                      className="xl:w-2/12 lg:w-2/12 md:w-2/12 py-2 px-2 flex items-center gap-2 justify-center fade-item-2"
                      style={{ border: "1px dashed white" }}
                    >
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        <a href="/homepage1">Home</a>
                      </span>
                      <span className="text-white font-semibold"> »</span>
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        Product
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:pt-16  lg:pt-16  md:pt-16  pt-12  headerbg1 xl:px-0 px-4 ">
        <div
          className=" bg-white rounded-md xl:pt-16  lg:pt-16 lg:px-4 md:pt-16 pt-12  container mx-auto shadow-xl grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 grid-cols-1"
          style={{ borderBottom: "1px solid #f7f7f7" }}
        >
          <div className="">
          <div className="mb-4"style={{ borderRight: "1px solid #d5d1d17d" }}>
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon5} alt="" />
            </div>
            <p className="  lg:text-base xl:text-base md:text-sm text-base text-blackk xl:pb-12 lg:pb-12 md:pb-12 text-lg pb-12 text-center xl:pt-4 lg:pt-4 pt-4 ">
              Innovating Food Solutions<br></br> for a Better Tomorrow
            </p>
            </div>
          </div>

          <div className="">
          <div className="mb-4"style={{ borderRight: "1px solid #d5d1d17d" }}>
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon6} alt="" />
            </div>
            <p className="xl:pt-4 lg:pt-4 pt-4 lg:text-base xl:text-base md:text-sm text-base text-blackk  xl:pb-12 lg:pb-12 md:pb-12 text-lg pb-12 text-center">
              Revolutionizing Food Processing<br></br> with Innovation
            </p>
            </div>
          </div>

          <div className="">
          <div className="mb-4"style={{ borderRight: "1px solid #d5d1d17d" }}>
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon7} alt="" />
            </div>
            <p className="xl:pt-4 lg:pt-4 pt-4 lg:text-base xl:text-base md:text-sm text-base text-blackk  xl:pb-12 lg:pb-12 md:pb-12 text-lg pb-12 text-center">
              Advancing Food Technology<br></br> with Smart Solutions
            </p>
            </div>
          </div>

          {/* extra div */}
          <div className="xl:hidden lg:hidden md:block sm:hidden hidden"></div>

          <div className="">
          <div className="mb-4">
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon8} alt="" />
            </div>
            <p className="xl:pt-4 lg:pt-4 pt-4 lg:text-base xl:text-base md:text-sm text-blackk  xl:pb-12 lg:pb-12 text-lg pb-12 text-center">
              Transforming Ideas into<br></br> Reality with Innovation
            </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="headerbg1 xl:pt-24 xl:pb-24 lg:pt-20 lg:pb-20 md:pt-16 md:pb-16 pt-12 pb-12">
        <div className="container mx-auto xl:px-0 lg:px-0 md:px-0 px-4">
          <h1 className="xl:text-6xl lg:text-4xl md:text-3xl text-2xl text-black text-center font-semibold ">
            <span className="text-blue">Customer Praise</span> for Our<br></br>{" "}
            Organic Online Store
          </h1>
          <div className="xl:ml-32 lg:ml-32 md:ml-16">
            <div className="xl:block lg:block md:block sm:hidden hidden">
              <Slider2 />
            </div>
            
           
          </div>
        </div>
      </section> */}

      <section className="headerbg1 xl:pt-16 xl:pb-24 lg:pt-12 lg:pb-20 md:pt-12 md:pb-16 pt-12 pb-12">
        <p className="xl:text-xl lg:text-lg md:text-lg text-lg font-bold text-blue text-center uppercase">
          Products
        </p>
        <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black text-center pt-4">
          Cutting-Edge Equipment for<br></br> Efficient Processing
        </h1>

        <div className="container mx-auto grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xl:gap-6 lg:gap-4 gap-4 xl:px-0 px-4 xl:mt-16 lg:mt-16 md:mt-12 mt-8">
          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={silos}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Silos
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Silos store milk in dairy processing, maintaining
                    temperature and hygiene for quality and efficiency in cheese
                    production.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={storagetanks}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Storage Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Storage tanks hold milk in dairy processing, maintaining
                    hygiene, preventing contamination, and ensuring a steady
                    supply.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={processtanks}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Process Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Process tanks mix, heat, cool, and ferment milk, ensuring
                    temperature control, hygiene, and product consistency.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={mixingtank}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Mixing Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Mixing tanks blend ingredients uniformly, ensuring texture,
                    emulsification, and temperature control for quality dairy
                    products.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={cpitanks}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    CIP Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    CIP tanks store and circulate cleaning solutions, sanitizing
                    equipment to ensure hygiene, efficiency, and food safety.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-10/12 w-8/12 object-contain"
                      src={incubationtanks}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Incubation Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Incubation tanks culture and ferment milk, maintaining
                    optimal conditions for texture and flavor development.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={buttermeltingtank}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl   text-xl pt-2">
                    Butter Melting Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Butter melting tanks gently liquefy butter, ensuring  preventing burning, and maintaining temperature
                    control.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={jackedtedtanks}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Jacketed Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Jacketed tanks regulate temperature by circulating heating
                    or cooling fluids, ensuring precise thermal control.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={ribbonblender}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Ribbon Blenders
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Ribbon blenders mix powders and granules evenly, ensuring
                    consistency and product quality.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={drymixingtank}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Dry Mixing Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Dry mixing tanks blend powdered ingredients evenly,
                    preventing clumps and ensuring consistency.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={milktank}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Milk Road Tankers
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Milk road tankers transport milk under controlled
                    conditions, ensuring freshness and safe delivery.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={insulatedtank}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Insulated Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Insulated tanks maintain stable temperatures, preserving
                    quality and ensuring food safety.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="">
        <div
          className="xl:pt-16 xl:pb-16 lg:pt-12 lg:pb-12 md:pt-16 md:pb-16 pt-12 pb-12 flex justify-end items-center animated-bg"
          style={{
            backgroundImage: `url(${bgg3})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container mx-auto xl:px-0 px-4  flex justify-end">
            <div
              className=" bg-opacity-90 xl:p-8 lg:p-4 md:p-4 p-4 rounded-lg shadow-lg  "
              style={{ backgroundColor: "#FFFFFFE0" }}
            >
              <h2 className="xl:text-3xl lg:text-2xl md:text-2xl text-2xl font-semibold text-blackk ">
                Why Choose Our Solutions ?
              </h2>

              <div className="xl:block lg:block md:block sm:hidden hidden">
                <p className="text-para xl:text-base lg:text-base text-base lg:mt-4 xl:mt-4 mt-4 ">
                  Our cutting-edge technologies enhance food processing
                  efficiency,
                  <br></br> ensuring superior quality and optimized
                  manufacturing.
                </p>
              </div>

              {/* mobile view */}
              <div className="xl:hidden lg:hidden md:hidden sm:block block">
                <p className="text-para text-base  mt-4 font-semibold">
                  Our cutting-edge technologies enhance food processing
                  efficiency, ensuring superior quality and optimized
                  manufacturing.
                </p>
              </div>

              <div className="xl:mt-6 lg:mt-4 mt-4">
                <div className="relative ">
                  <h3 className="xl:text-xl lg:text-xl md:text-xl text-xl font-semibold text-blackk flex items-center">
                    <i className="fas fa-cogs text-blue mr-2 text-2xl"></i>{" "}
                    Advanced Processing Equipment
                  </h3>

                  <div className="xl:block lg:block md:block sm:hidden hidden">
                    <p className="text-para xl:text-base lg:text-base text-base lg:pt-2 xl:pl-8 xl:pt-4 pt-2">
                      Our state-of-the-art machinery ensures faster, more
                      efficient
                      <br></br> food production with consistent quality output.
                    </p>
                  </div>
                  {/* mobile view */}
                  <div className="xl:hidden lg:hidden md:hidden sm:block block">
                    <p className="text-para text-base pt-2 ">
                      Our state-of-the-art machinery ensures faster, more
                      efficient food production with consistent quality output.
                    </p>
                  </div>
                </div>

                <div className="relative xl:mt-6 lg:mt-4 mt-4">
                  <h3 className="xl:text-xl lg:text-xl md:text-xl text-xl font-semibold text-blackk flex items-center">
                    <i className="fas fa-industry text-blue mr-2 text-2xl"></i>{" "}
                    Precision Manufacturing Solutions
                  </h3>

                  <div className="xl:block lg:block md:block sm:hidden hidden">
                    <p className="text-para  xl:text-base lg:text-base text-base pt-2 lg:pt-2 xl:pl-8 xl:pt-4">
                      We provide tailored manufacturing solutions to enhance
                      <br></br> productivity and meet evolving industry demands.
                    </p>
                  </div>
                  {/* mobile view */}
                  <div className="xl:hidden lg:hidden md:hidden sm:block block">
                    <p className="text-para text-base pt-2 ">
                      We provide tailored manufacturing solutions to enhance
                      productivity and meet evolving industry demands.
                    </p>
                  </div>
                </div>
              </div>

              <div className="xl:mt-6 lg:mt-4 mt-4">
                <a href="/service">
                  <button className="blue text-white font-semibold xl:py-4 xl:px-6 lg:px-4 lg:py-2 rounded-lg hover:bg-green-700 px-2 py-2">
                    Explore Our Solutions <span className="ml-2">+</span>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
}
